import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const addOrEditDecorator = (params, isEdit) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop_decorator`,
    method: isEdit ? "PUT" : "POST",
    data: params,
  });
};
export const delDecorator = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop_decorator/${ids}`,
    method: "DELETE",
  });
};
// 获取列表
export const getDecoratorList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop_decorator?` + params,
    method: "GET",
  });
};
// 获取详情
export const getDecoratorDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop_decorator/${id}`,
    method: "GET",
  });
};